import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loanSuccessPage extends cc.Component {
    
    @property({type:cc.Label,tooltip:"描述文本"})
    lbExplain:cc.Label = null;

    @property({type:cc.Label,tooltip:"次数文本"})
    lbCount:cc.Label = null;

    bindData(totalMoney:string,rate:string,limit:string,dayMoney:string){
        this.lbExplain.string = `成功贷款${totalMoney},日利率${rate}\n期限${limit}日还清，每日还款${dayMoney}`;
        this.lbCount.string = `(剩余贷款次数：${NormalGameManager._instance.getGameData().loanCount}/3)`;
    }

    protected start(): void {
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.LOANSUCCESSPAGE);
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();

        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.LOANSUCCESSPAGE);
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }
}
